import React from 'react';
import { Button, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconClockPause } from '@tabler/icons-react';
import { useAppBreakpoint } from '../../hooks/useAppBreakpoint';
import { TRANSLATIONS } from '../../constants/translations';
import { translate } from '../../helpers/translationHelper';
import { SURFACE_1_SOFT, TEAL, TEAL_SOFT_BG } from '../../theme/creamyTokens';

const { Title, Paragraph } = Typography;

/**
 * What /register shows while nobody new can sign up.
 *
 * A page rather than a redirect, because somebody who typed or followed a
 * link to the registration form is owed an answer to "why is this not
 * here?" -- bouncing them silently to the home page reads as a broken link.
 * The one button sends them where they can still do something useful: the
 * waiting list.
 *
 * Purely informational. The refusal that matters happens in the API
 * (AuthController.Register), which turns the POST down whether or not this
 * page was ever rendered.
 */
const RegistrationClosed: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useAppBreakpoint();

  return (
    <div
      style={{
        minHeight: '100vh',
        background: SURFACE_1_SOFT,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
    >
      <div style={{ maxWidth: 420, width: '100%', textAlign: 'center' }}>
        <span
          style={{
            display: 'inline-flex',
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: TEAL_SOFT_BG,
            color: TEAL,
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 16,
          }}
        >
          <IconClockPause size={28} />
        </span>
        <Title level={3} style={{ marginTop: 0, fontSize: isMobile ? 22 : 26 }}>
          {translate(t, TRANSLATIONS.REGISTRATION_CLOSED_TITLE)}
        </Title>
        <Paragraph type="secondary" style={{ fontSize: 15 }}>
          {translate(t, TRANSLATIONS.REGISTRATION_CLOSED_BODY)}
        </Paragraph>
        <Button type="primary" size="large" block style={{ borderRadius: 999, height: 48 }} onClick={() => navigate('/proximamente')}>
          {translate(t, TRANSLATIONS.REGISTRATION_CLOSED_CTA)}
        </Button>
      </div>
    </div>
  );
};

export default RegistrationClosed;
